export default function ScrollOffset () {
  const isSearchRoute = document.body.className.indexOf('search-page-route') !== -1
  const isCourseSingle = document.body.className.indexOf('single-course') !== -1
  if (!isSearchRoute && !isCourseSingle) {
    localStorage.setItem('scrollOffset', '0')
  }
}